import { useState, useCallback } from 'react';

/**
 * Form state yönetimi için Generic Hook.
 * @param initialValues Formun başlangıç değerleri
 */
export function useForm<T>(initialValues: T) {
  const [values, setValues] = useState<T>(initialValues);
  const [errors, setErrors] = useState<Partial<Record<keyof T, string>>>({});

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    
    setValues(prev => {
      // Checkbox kontrolü
      if (type === 'checkbox') {
        const checked = (e.target as HTMLInputElement).checked;
        return { ...prev, [name]: checked };
      }
      
      // Number kontrolü (HTML input type="number" olsa bile string döner, parse ediyoruz)
      if (type === 'number') {
        return { ...prev, [name]: value === '' ? null : Number(value) };
      }

      // Standart text/select
      return { ...prev, [name]: value };
    });

    // Değişiklik olduğunda ilgili alanın hatasını temizle
    if (errors[name as keyof T]) {
      setErrors(prev => ({ ...prev, [name]: undefined }));
    }
  }, [errors]);

  // Manuel olarak bir alanı set etmek için (Örn: Date picker, Custom Select)
  const setFieldValue = useCallback((name: keyof T, value: any) => {
    setValues(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: undefined }));
    }
  }, [errors]);

  const resetForm = useCallback(() => {
    setValues(initialValues);
    setErrors({});
  }, [initialValues]);

  return {
    values,
    errors,
    setErrors,
    handleChange,
    setFieldValue,
    resetForm,
    setValues // Tüm formu dışarıdan güncellemek için
  };
}